import { SubcategoryToAddModel } from "./subcategory-to-add.model";
import { MenuItemToAddModel } from "./menu-item-to-add.model";

export class CategoryToAddModel {
  public id: string;
  public subCategories: Array<SubcategoryToAddModel>;
  public menuItems: Array<MenuItemToAddModel>;
}
